import styled from 'styled-components';
import { Form } from 'antd';

export const FacilityTemplatesList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  max-height: 400px;
  overflow-y: auto;
  padding: 16px 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const FacilityTemplateCard = styled.div`
  padding: 20px;
  border: 2px solid #e8e8e8;
  border-radius: 8px;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.3s ease;
  background-color: ${props => (props.disabled ? '#f5f5f5' : '#fafafa')};
  color: ${props => props.color};
  opacity: ${props => (props.disabled ? 0.6 : 1)};
  position: relative;

  &:hover {
    border-color: ${props => (props.disabled ? '#e8e8e8' : '#1890ff')};
    box-shadow: ${props =>
      props.disabled ? 'none' : '0 4px 12px rgba(24, 144, 255, 0.15)'};
    transform: ${props => (props.disabled ? 'none' : 'translateY(-2px)')};
  }

  &:active {
    transform: ${props => (props.disabled ? 'none' : 'translateY(0)')};
  }
`;

export const StyledForm = styled(Form)`
  .ant-form-item {
    margin-bottom: 20px;
  }

  .ant-form-item-label {
    padding: 0;
  }
`;

export const FormContainer = styled.div`
  padding: 16px 8px;
  max-height: 450px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const StepIndicator = styled.div`
  background-color: #1890ff;
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
`;

export const StepTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${props => props.color};
  margin-bottom: 16px;
  text-align: center;
`;

export const ImportedBadge = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  background-color: #52c41a;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
`;

export const UserListContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e8e8e8;
  border-radius: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const UserListTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const UserListHeaderRow = styled.tr`
  background-color: #f5f5f5;
`;

export const UserListHeaderCell = styled.th`
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 13px;
  color: #666;
  border-bottom: 2px solid #e8e8e8;
  white-space: nowrap;

  &:last-child {
    white-space: nowrap;
    width: 120px;
    min-width: 120px;
  }
`;

export const UserListRow = styled.tr`
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #fafafa;
  }
`;

export const UserListCell = styled.td`
  padding: 12px 16px;
  color: ${props => props.color || 'inherit'};
  font-size: 14px;
  text-align: left;
  word-break: break-word;
`;
